import { connect } from 'react-redux';
import { get } from 'lodash';

import CreateAppointmentSuccess from './CreateAppointmentSuccess';

const mapStateToProps = (state) => ({
  serviceName: get(state, 'appointmentsManagement.createAppointment.details.service.name'),
  requestStatus: state.appointmentsManagement.createAppointment.requestStatus,
});

export default connect(mapStateToProps)(CreateAppointmentSuccess);
